import React from "react";
import { useEffect, useState } from "react";

const WAIT_PERIOD = 500;
export function useCooldown<T>(initial: T): [T, React.Dispatch<React.SetStateAction<T>>] {
    const [fastValue, setFastValue] = useState<T>(JSON.parse(JSON.stringify(initial)));
    const [slowValue, setSlowValue] = useState<T>(JSON.parse(JSON.stringify(initial)));
    const [timerValue, setTimerValue]  = useState<any>(null);

    useEffect(() => {
        if (timerValue) {
            clearTimeout(timerValue);
            setTimerValue(null);
        }
        let timer = setTimeout(() => {
            
            setSlowValue(JSON.parse(JSON.stringify(fastValue))); //replace the reference
        }, WAIT_PERIOD);
        setTimerValue(timer);
    }, [fastValue])

    return [slowValue, setFastValue];
}